import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import First from './components/First';
import Home from './components/Home'; // Import Home component
import Pl from './components/Pl';
import TopD from './components/TopD';
import Contact from './components/Contact';
import Bs from './components/Bs';
import Inv from './components/Inv';
import Com from './components/Com';







function App() {
  return (
    <Router>
       
      <Routes>
        <Route path="/" element={<First />} />
        <Route path="/home" element={<Home />} /> 
        <Route path="/pl" element={<Pl />} />
        <Route path="/bs" element={<Bs />} />
        <Route path="/inv" element={<Inv />} />
        <Route path="/com" element={<Com />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/topd" element={<TopD />} />
      </Routes>
 
    </Router>
  );
}

export default App;
